import type { Program } from 'models';
import { Avatar, Flex, RichTextRenderer, Text } from 'ui';

type P = {
  program: Program;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramAuthor = ({ program }: P) => (
  <Flex gap="middle" vertical>
    <Text>Authored by</Text>
    <Flex align="center" gap="middle">
      <Avatar photo={program.author.profilePhoto?.url} />
      <Text>{program.authorName}</Text>
    </Flex>
    {program.htmlAuthorOverview ? (
      <RichTextRenderer data={program.htmlAuthorOverview} />
    ) : (
      <Text>{program.authorOverviewText}</Text>
    )}
  </Flex>
);

export default ProgramAuthor;
